module.exports = __webpack_public_path__ + "img/Transparant.2dbf9c8c.png";